// extracted by mini-css-extract-plugin
export var lg = "_e4-7";
export var md = "_e4-6";
export var placeholderContainer = "_e4-1";
export var placeholderIcon = "_e4-2";
export var productImage = "_e4-0";
export var sm = "_e4-5";
export var xl = "_e4-8";
export var xs = "_e4-4";
export var xxs = "_e4-3";